import sagas from './sagas';

export default {
    sagas,
};
